import CartPageMobile from "@/pages-react/cart-page/cart-page.mobile.tsx";
import CartPageDesktop from "@/pages-react/cart-page/cart-page.desktop.tsx";
import { LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import { Services } from "@/services/services";
import { LocationHook, RouteHook, useLocation, useRoute } from "preact-iso";
import { pageSuspense, useSuspenseLoader } from "@/helpers/suspense";
import { useServices } from "@/services-context";
import { PageTags } from "@/elements-react/document-elements/page-tags.tsx";
import { SeoMarkupDataset } from "@/services/seo-markup.ts";
import { Url } from "@/helpers/url.ts";

const fetchPageData = async (params: { services: Services; location: LocationHook; route: RouteHook }) => {
  const { services, location, route } = params;

  const registryUrl = Url.normalizeRoute(route.path);
  const alternates = await services.routes.resolveAlternates(registryUrl);

  await services.initialize.prepare({
    location: location,
    route: route,
  });

  await services.cart.fetchCart();

  return {
    type: "static",
    canonical: registryUrl,
    alternates: alternates,
  };
};

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return CartPageDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return CartPageMobile;
  }
};

const CartPage = pageSuspense(() => {
  const route = useRoute();
  const location = useLocation();
  const services = useServices();
  const { layoutType } = useLayoutType();

  const seoMarkupDataset = useSuspenseLoader({
    key: "cart-route",
    loader: () =>
      fetchPageData({
        services: services,
        location: location,
        route: route,
      }),
  }) as SeoMarkupDataset;

  const PageComponent = getPageComponent(layoutType);

  return (
    <div style={{ display: "contents" }}>
      <PageComponent />
      <PageTags seo={seoMarkupDataset} />
    </div>
  );
});

export { CartPage };
